<script setup>

import { onMounted } from 'vue';
import { useThemeStore } from './stores/themeStore';

const themeStore = useThemeStore();

onMounted(()=>{
  themeStore.loadTheme();
});

</script>

<template>
  <router-view v-if="themeStore.theme" />
 
</template>

<style scoped>

</style>
